


import styles from '../../portfolio/Portfolio.module.css'

const Project = ({ projects,className }) => {

    const proj = projects.map((item)=>{
        const{img,title,link} = item

        return(

            <div className={`${styles.singleProjectWrapper} ${className}`}>
                <div className='flex justify-center items-center h-1/2'>
                    <img className={styles.icon} src={img} alt={title} />
                </div>
                <div className={styles.hiddenBlock}><a className={styles.link} href={link}>Go To</a></div>
                <div>
                    <h1 className={styles.titleText}>{title}</h1>
                </div>
            </div>
        )
    })


    return(proj)
}

export default Project